import { queryOptions } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";
import {
  ClassroomReadingLevelFilters,
  ClassroomReadingLevelResponse,
} from "@/reports/types";

export const classroomReadingLevelQueries = {
  all: () => [ApiCatalog.classroomReadingLevel.key] as const,
  filter: (queryParams: ClassroomReadingLevelFilters, enabled = true) =>
    queryOptions({
      queryKey: [...classroomReadingLevelQueries.all(), { ...queryParams }],
      queryFn: () =>
        api().get<ClassroomReadingLevelResponse>(
          ApiCatalog.classroomReadingLevel.endpoint,
          {
            queryParams: {
              ...queryParams,
              entity_type: "classroom",
            },
          },
        ),
      enabled,
    }),
};
